import { find } from "lodash";
import { PRODUCT_DETAILS } from "@ipru-common/constants/products";

export const HotjarService = {
  pushEvent: ({ event, productCode }) => {
    const productShortName = find(PRODUCT_DETAILS, {
      key: productCode,
    })?.shortName;
    const eventLabel = `${productShortName}_${event}`;
    window.hj =
      window.hj ||
      function () {
        (window.hj.q = window.hj.q || []).push(arguments);
      };
    window.hj("event", eventLabel);
    window.hj("stateChange", eventLabel);
  },
};
